module.exports = __webpack_public_path__ + "static/media/bpsu.logo.160w.c890e6e0.jpg";